import get from 'lodash.get';

import { selectResendEmailConfirmation } from '../../../../redux/auth/resendEmailConfirmation/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

export const selectIsLoading = createDeepEqualSelector(selectResendEmailConfirmation, (emailActivation) =>
  get(emailActivation, 'loading', false),
);

export const selectError = createDeepEqualSelector(selectResendEmailConfirmation, (emailActivation) =>
  get(emailActivation, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectResendEmailConfirmation, (emailActivation) =>
  get(emailActivation, 'errMsg', 'Error'),
);
